import { logSessionFetchDiagnostic } from '@/shared/auth/session-fetch-log'
import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import { useQuery } from '@tanstack/react-query'

interface UseSessionProps {
  required?: boolean
  redirectTo?: string
  queryConfig?: {
    onSettled?: (data: any, error: any) => void
  }
}

export const fetchSession = async () => {
  const res = await fetch('/api/auth/session')
  const bodyText = await res.text()
  logSessionFetchDiagnostic(res, bodyText)

  if (!bodyText.trim()) return null

  let session: Record<string, unknown>
  try {
    session = JSON.parse(bodyText) as Record<string, unknown>
  } catch {
    console.error('[gamification-session] failed to parse session JSON', {
      status: res.status,
      contentType: res.headers.get('content-type') ?? ''
    })
    return null
  }

  if (Object.keys(session).length) return session

  return null
}

export const useSession = ({
  required,
  redirectTo = '/api/auth/signin?error=SessionExpired',
  queryConfig = {}
}: UseSessionProps = {}) => {
  const router = useRouter()
  const query = useQuery(['session'], fetchSession, {
    ...queryConfig,
    onSettled(data, error) {
      if (queryConfig.onSettled) queryConfig.onSettled(data, error)
      if (data || !required) return
      router.push(redirectTo)
    }
  })

  return query
}
